import React, { memo, useEffect, useRef } from "react";
import { useLogicalSelectedPage } from "../../../hooks/useSelection";
import { useBackground } from "../background-color-panel/hooks/useBackground";
import { BackgroundPatternPanel, IBackgroundPatternsPanelRef } from "./background-pattern-panel";
import { useBackgroundPatterns } from "./hooks/useBackgroundPatterns";
import { useSetPatternBackground } from "./hooks/useSetPatternBackground";

export const BackgroundPatternPanelContainer = memo(() => {
	const backgroundPatterns = useBackgroundPatterns();
	const background = useBackground();
	const panelRef = useRef<IBackgroundPatternsPanelRef>(null);

	const setPatternBackground = useSetPatternBackground();

	const page = useLogicalSelectedPage();
	const aspectRatio = page ? page.width / page.height : 1;

	useEffect(() => {
		if (panelRef.current) panelRef.current.scrollIntoView(true);
	}, [background]);

	useEffect(() => {
		if (panelRef.current) panelRef.current.scrollIntoView(false);
	}, [backgroundPatterns]);

	return (
		<BackgroundPatternPanel
			ref={panelRef}
			patterns={backgroundPatterns}
			aspectRatio={aspectRatio}
			selectedPatternBackground={
				background instanceof eXpress.core.StockBackground ? background : undefined
			}
			onClick={(patternBackground) => {
				if (setPatternBackground) {
					setPatternBackground(patternBackground);
				}
			}}
		/>
	);
});
BackgroundPatternPanelContainer.displayName = "BackgroundPatternPanelContainer";
